import { redirect } from '@tanstack/react-router';
import { rewriteLegacyIdeaManagementPath } from '@tempo-io/notification-registry';

type OrgIdSplatBeforeLoadArgs = {
  context: { organizationId?: string; organizationName?: string };
  params: { orgId: string; _splat?: string };
  location: { searchStr?: string; hash?: string };
};

export const resolveOrgIdSplatPath = (splat: string | undefined): string =>
  rewriteLegacyIdeaManagementPath(splat ?? '');

export const orgIdSplatBeforeLoad = ({ context, params, location }: OrgIdSplatBeforeLoadArgs) => {
  const { organizationId, organizationName } = context;
  const remainingPath = resolveOrgIdSplatPath(params._splat);

  if (params.orgId === organizationId && organizationName) {
    const searchAndHash = `${location.searchStr ?? ''}${location.hash ? `#${location.hash}` : ''}`;
    throw redirect({
      href: `/org/${organizationName}/${remainingPath}${searchAndHash}`,
      replace: true,
    });
  }
};
